import { render, staticRenderFns } from "./OrderTypeSelector.vue?vue&type=template&id=a2252a16&scoped=true"
import script from "./OrderTypeSelector.vue?vue&type=script&lang=ts"
export * from "./OrderTypeSelector.vue?vue&type=script&lang=ts"
import style0 from "./OrderTypeSelector.vue?vue&type=style&index=0&id=a2252a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2252a16",
  null
  
)

export default component.exports